import React from 'react';

/**
 * MidCTA — bordeaux mid-page nudge. NOT auto-numbered (no .section-label).
 * Pass `onStartFunnel` to wire the primary button.
 */
export default function MidCTA({ onStartFunnel }) {
  return (
    <section
      className="mid-cta"
      style={{
        padding: '120px 0',
        background: 'var(--bordeaux)',
        color: 'var(--cream)',
      }}
    >
      <div className="shell">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.4fr 1fr',
            gap: 80,
            alignItems: 'center',
          }}
        >
          <div className="reveal">
            <h2
              className="h-section"
              style={{
                color: 'var(--cream)',
                fontSize: 'clamp(32px, 3.6vw, 46px)',
                maxWidth: '20ch',
                lineHeight: 1.1,
              }}
            >
              Sichern Sie sich jetzt Ihre unverbindliche Erstanalyse.
            </h2>
            <p
              style={{
                marginTop: 22,
                fontFamily: 'var(--serif)',
                fontStyle: 'italic',
                fontSize: 20,
                color: 'rgba(245,242,236,0.78)',
                maxWidth: '44ch',
              }}
            >
              Kostenlos und unverbindlich.
            </p>
          </div>

          <div className="reveal" style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <button
              type="button"
              onClick={onStartFunnel}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                padding: '18px 32px',
                background: 'var(--cream)',
                color: 'var(--bordeaux)',
                fontFamily: 'var(--grotesk)',
                fontSize: 14,
                letterSpacing: '0.08em',
                fontWeight: 500,
                border: '1px solid var(--cream)',
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'background 200ms ease, color 200ms ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'var(--cream)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'var(--cream)';
                e.currentTarget.style.color = 'var(--bordeaux)';
              }}
            >
              Erstanalyse anfragen <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
